module.exports = __webpack_public_path__ + "img/pengboshi01.f213847e.png";